import modular from "modujs";
import * as modules from "./_modules";
// import "./_lazyload";
import { setupAOS, setupIframes } from "./_animations";

setupIframes();

const app = new modular({
    modules: modules,
});

window.addEventListener('load', event => {
    const $style = document.getElementById("main-css");
    if ($style) {
        if ($style.isLoaded) {
            init();
        } else {
            $style.addEventListener("load", (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }
});

function init() {
    app.init(app);
    document.documentElement.classList.add("is-loaded", "is-ready");
    document.documentElement.classList.remove("is-loading");   
    setupAOS();
}
